module.exports = __webpack_public_path__ + "static/media/20d-01-HOME_ST-2020-1553x1335mm-oleo-sobre-tela.a9a7f1d2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gallery/20d/20d-01-HOME_ST-2020-1553x1335mm-oleo-sobre-tela.jpg
// module id = 253
// module chunks = 0